import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const STACK = [{
  name: 'Sistema de Diagnóstico Facial · 6 Tomos Clínicos Premium',
  value: '$97 USD'
}, {
  name: 'Calculadora Inteligente de Honorarios Clínicos',
  value: '$27 USD'
}, {
  name: 'Protocolo de Presentación del Plan de Tratamiento',
  value: '$29 USD'
}, {
  name: 'Biblioteca de 20 Casos Clínicos Resueltos',
  value: '$47 USD'
}, {
  name: 'Biblioteca de los 50 Errores de Diagnóstico Facial',
  value: '$37 USD'
}, {
  name: 'Checklist Maestro de Diagnóstico en 15 Minutos',
  value: '$27 USD'
}];
export function Offer() {
  return <section id="oferta" className="w-full bg-navy-900 px-4 py-14 text-white sm:py-20" data-id="element-217" data-mp="3nvk5qv4f7q5k">
      <div className="mx-auto max-w-xl" data-id="element-218" data-mp="3swzrkpefa0p0">
        <h2 className="text-center font-display text-[26px] font-bold leading-[1.15] tracking-tight sm:text-4xl" data-id="element-219" data-mp="3su3pqpzgerva">
          Esto es todo lo que obtienes
        </h2>

        <ul className="mt-7 divide-y divide-white/10 rounded-3xl border border-white/10 bg-white/5 px-4 sm:px-5" data-id="element-220" data-mp="1km9nr8mu4fw7">
          {STACK.map(item => <li key={item.name} className="flex items-start justify-between gap-3 py-3.5" data-id="element-221" data-mp="1bkifpx4tnwz6">
              <span className="flex items-start gap-2.5" data-id="element-222" data-mp="16lp1u3lmi3yh">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-223" data-mp="16n9v7pw7bgur" />
                <span className="text-[13.5px] font-medium leading-snug text-white/90 sm:text-[15px]" data-id="element-224" data-mp="23bg7myzd7djl">
                  {item.name}
                </span>
              </span>
              <span className="shrink-0 text-[12.5px] font-semibold text-white/45 line-through sm:text-sm" data-id="element-225" data-mp="1uiutjw6ohv13">
                {item.value}
              </span>
            </li>)}
        </ul>

        <div className="mt-4 flex items-center justify-between gap-3 rounded-2xl border border-white/10 px-4 py-3" data-id="element-226" data-mp="2n076kzl75g59">
          <span className="text-[11.5px] font-bold uppercase tracking-[0.12em] text-white/60" data-id="element-227" data-mp="2i8gq0bvo1w5e">
            Valor total del sistema
          </span>
          <span className="font-display text-xl font-bold text-white/70 line-through" data-id="element-228" data-mp="364k9xr9bxq2j">$264 USD</span>
        </div>

        <div className="mt-7 rounded-3xl bg-white p-5 text-navy-900 shadow-soft sm:p-7" data-id="element-229" data-mp="2sdoyq8bcywvs">
          <p className="text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-230" data-mp="2wein12spqdp7">
            Oferta especial de lanzamiento
          </p>
          <p className="mt-3 text-center text-[13.5px] font-medium text-navy-500" data-id="element-231" data-mp="2idob4a6ghuls">
            Hoy puedes acceder por solo
          </p>
          <p className="mt-1 text-center font-display text-[54px] font-bold leading-none tracking-tight text-navy-900 sm:text-6xl" data-id="element-232" data-mp="29eks167ahf7a">
            $12.99
            <span className="ml-1 align-middle text-lg font-semibold text-navy-400" data-id="element-233" data-mp="2dgep74ia012p">USD</span>
          </p>

          <p className="mt-3 flex items-center justify-center gap-2 rounded-2xl bg-cream px-3 py-2.5 text-center text-[12px] font-semibold leading-snug text-navy-700 sm:text-[13px]" data-id="element-234" data-mp="7npt45hsczwc">
            <GlobeIcon className="h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-235" data-mp="1w7dgk3qq6l2u" />
            El cambio de moneda es automático: pagas en la moneda de tu país.
          </p>

          <ul className="mt-4 grid gap-1.5 text-center text-[13px] font-medium text-navy-600" data-id="element-236" data-mp="25wnew1c5wzze">
            <li data-id="element-237" data-mp="215f00ps2cmeu">Un único pago. Sin mensualidades.</li>
            <li data-id="element-238" data-mp="213u714ledbj3">Sin renovaciones.</li>
            <li data-id="element-239" data-mp="2fu1opi3kyqiq">Acceso inmediato y de por vida.</li>
          </ul>

          <div className="mt-5 rounded-2xl border border-navy-100 bg-cream px-4 py-4" data-id="element-240" data-mp="2fwe8m0swfayf">
            <ScarcityBar spotsLeft={9} totalSpots={120} data-id="element-241" data-mp="2axkrlyeel1ti" />
          </div>

          <div className="mt-5" data-id="element-242" data-mp="2oupu5oewrik0">
            <CtaButton label="Quiero el Sistema de Diagnóstico Facial" location="oferta" note="Descarga inmediata • Pago único • Garantía de 7 días" data-id="element-243" data-mp="2osvjr419j8u6" />
          </div>

          <div className="mt-4" data-id="element-244" data-mp="pidq5640d981">
            <Countdown label="El precio promocional expira en" data-id="element-245" data-mp="pjfa6030561w" />
          </div>
        </div>
      </div>
    </section>;
}